export default "dist/images/block-team-member-plain.4bd17e6.png";